import CyrillicToTranslit from 'cyrillic-to-translit-js';

// @ts-ignore
const cyrillicToTranslit = new CyrillicToTranslit({ preset: 'uk' });

export const makeTransliteration = (value: string): string => {
    return cyrillicToTranslit.transform(value, '_');
};
